import { WHITE } from '../../theme/ColorConstants';
const TOOLTIP_BACKGROUND_COLOR = '#425b76';
export const getTooltipBackgroundColor = () => TOOLTIP_BACKGROUND_COLOR;
export const getTooltipTextColor = () => WHITE;